/* Gorgias owns the button and its events; only its closed appearance is changed. */
(() => {
  const script = document.currentScript;
  const full = script?.dataset.fullIcon;
  const compact = script?.dataset.compactIcon;
  if (!full || !compact) return;

  const loadImage = (src) => new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = reject;
    image.src = src;
  });

  const ready = window.GorgiasChat
    ? Promise.resolve(window.GorgiasChat.init())
    : new Promise((resolve) => window.addEventListener('gorgias-widget-loaded', resolve, { once: true }));

  Promise.all([loadImage(full), loadImage(compact), ready]).then(([, mobileImage]) => {
    const chat = window.GorgiasChat;
    if (!chat) return;
    const mobile = window.matchMedia('(max-width: 749px)');
    // Let the browser resolve SVG viewBox ratios as well as raster dimensions.
    mobileImage.style.cssText = 'position:fixed;visibility:hidden;height:50px!important;width:auto!important;max-width:none!important;max-height:none!important';
    document.body.appendChild(mobileImage);
    const mobileWidth = Math.max(1, Math.min(280, Math.round(mobileImage.getBoundingClientRect().width) || 50));
    mobileImage.remove();
    let open = typeof chat.isOpen === 'function' && chat.isOpen();
    let frame;
    let style;
    let frameStyle;
    let timer;

    const update = () => {
      if (!frame || !style) return;
      // The engagement teaser also uses the button as its close control.
      const engagementOpen = !!document.querySelector('#mount-floating-engagement-widget[aria-hidden="false"]');
      const useArtwork = !open && !engagementOpen;
      const width = mobile.matches ? Math.min(mobileWidth, window.innerWidth - 40) : 145;
      // The style element's media attribute actually disables its rules;
      // assigning style.disabled does not reliably disable a style sheet.
      style.media = useArtwork ? 'all' : 'not all';
      frameStyle.media = useArtwork ? 'all' : 'not all';
      style.textContent = `
        #gorgias-chat-messenger-button { position: relative !important; width: ${width}px !important; height: 50px !important; padding: 0 !important; border: 0 !important; background: transparent !important; box-shadow: none !important; }
        #gorgias-chat-messenger-button > * { visibility: hidden !important; }
        #gorgias-chat-messenger-button::after { content: ''; position: absolute; inset: 0; visibility: visible; background: center / contain no-repeat url(${JSON.stringify(mobile.matches ? compact : full)}); pointer-events: none; }
      `;
      // Gorgias updates the inline width on render; a stylesheet keeps the
      // entire button visible without fighting its inline-style mutations.
      frameStyle.textContent = `#gorgias-chat-container #chat-button { width: ${width + 20}px !important; }`;
    };

    const attach = () => {
      const next = document.querySelector('#gorgias-chat-container #chat-button');
      if (!next) return false;
      try {
        const doc = next.contentDocument;
        if (!doc?.head || !doc.querySelector('#gorgias-chat-messenger-button')) return false;
        if (frame !== next || style?.ownerDocument !== doc || !style.isConnected) {
          frame = next;
          style = doc.createElement('style');
          doc.head.appendChild(style);
        }
        if (!frameStyle) {
          frameStyle = document.createElement('style');
          document.head.appendChild(frameStyle);
        }
        update();
        return true;
      } catch (_) {
        return false;
      }
    };

    const waitForButton = () => {
      if (attach() || timer) return;
      let attempts = 0;
      timer = window.setInterval(() => {
        if (attach() || ++attempts >= 200) {
          window.clearInterval(timer);
          timer = null;
        }
      }, 50);
    };

    // Gorgias removes and recreates the button iframe when chat is opened.
    const observer = new MutationObserver(waitForButton);
    observer.observe(document.body, {
      subtree: true, childList: true, attributes: true, attributeFilter: ['aria-hidden']
    });
    chat.on('widget:opened', () => { open = true; update(); });
    chat.on('widget:closed', () => { open = false; waitForButton(); });
    mobile.addEventListener('change', update);
    waitForButton();
  }).catch(() => {
    // Keep the original Gorgias button when artwork or initialization fails.
  });
})();
